import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../../../componentsTopsa/inputs/TopInputs";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import DataFormat from "../../../../../../utilities/DateAndTimeFormat";
import moment from "moment";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import TopDostepnosc from "../../../../../../componentsTopsa/dostepnosc/TopDostepnosc";

export default class PokazRozkladForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            trasa: null,
            godzina: null,
            validatorMessages: [],
        };
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeGodzina = this.onChangeGodzina.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
        this.setState({data: moment()})
    }

    onChangeData(e) {
        this.setState({data: e, godzina: null})
        if (e !== null && Boolean(this.state.trasa)) {
            this.props.handleSzukajGodzin(this.state.trasa, e)
        }
    }

    onChangeGodzina(e) {
        this.setState({godzina: e})
    }

    onChangeTrasa(e) {
        this.setState({trasa: e, godzina: null})
        if (e !== null && Boolean(this.state.data)) {
            this.props.handleSzukajGodzin(e, this.state.data)
        }
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0} wartosc={option.status} czyMarginesLewy={true}/></div>
    }

    formatSelectGodzina(option) {
        return DataFormat.formatHHMM(option.godz1p)
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickSzukaj() {

        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.trasa)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano trasy')
        }

        if (!Boolean(this.state.data)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano daty')
        }

        if (poprawne) {
            this.setState({validatorMessages: []})
            this.props.handleSzukaj(DataFormat.formatYYYYMMDD(this.state.data), this.state.trasa, this.state.godzina)
        }
    }

    render() {

        return (
            <Form horizontal={true}>
                <FormGroup>

                    <Col xs={12} lg={5}>
                        <ControlLabel>Trasa <span className={'req'}>*</span></ControlLabel>
                        <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy} labelKey={'nazTr'}
                                   valueKey={'idTr'} valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}/>
                    </Col>
                    <Col xs={12} lg={3}>
                            <ControlLabel>Data <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeData} value={this.state.data} horizontal={true}/>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div className={'add-label-margin'}></div>
                        <TopButtonAction text={'Szukaj w rozkładzie'} iconType={'fa fa-search'} btnSize={'medium'} onClick={this.onClickSzukaj}/>
                    </Col>
                </FormGroup>
                <FormGroup>
                    <ValidatorMessages messages={this.state.validatorMessages}/>
                </FormGroup>
            </Form>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/pokazRozklad/components/PokazRozkladForm.js